import type { RecoProductCardFragment } from '@packages/gql/generated/shopping/graphql';
import type { ProductCardV2EnergyEfficiencyFlagsProps } from '@packages/modules/src/ProductCardV2/ProductCardV2.EnergyEfficiencyFlags.client';
import { getValidColorAndEfficiencyClass } from '@packages/shared/src/ui/EnergyEfficiencyFlag/colorsForEnergyEfficiency';

export const getEnergyEfficiencyFlags = (
  energyFlags: NonNullable<RecoProductCardFragment['product']>['powerEfficiencyFlags'],
) => {
  const flags: ProductCardV2EnergyEfficiencyFlagsProps['flags'] = [];

  if (energyFlags && energyFlags.length > 0) {
    energyFlags.forEach((flag) => {
      const colorAndEfficiencyClass = getValidColorAndEfficiencyClass(flag.color);

      if (colorAndEfficiencyClass === undefined) {
        return;
      }
      const { color, efficiencyClass } = colorAndEfficiencyClass;

      const overlay: ProductCardV2EnergyEfficiencyFlagsProps['flags'][0]['overlay'] = {
        title: flag.text,
        imgUrl: flag.link,
      };

      // datasheetKeys is an array that may contain nulls, so we use the first non-empty key to
      // create the datasheet link (a leading null must not hide a valid, later key)
      const datasheetKey = flag.dataSheetKeys.find((key) => key);
      const datasheet: ProductCardV2EnergyEfficiencyFlagsProps['flags'][0]['datasheet'] =
        datasheetKey ? { url: datasheetKey, name: 'Produktdatenblatt' } : undefined;

      if (flag.hasOldLabel) {
        flags.push({
          variant: 'legacy',
          overlay,
          color,
          text: flag.level,
          size: 'medium',
          datasheet,
        });
      } else {
        flags.push({
          variant: 'new',
          overlay,
          efficiencyClass,
          size: 'medium',
          datasheet,
        });
      }
    });
  }

  return flags;
};
